export default __webpack_public_path__ + "static/6674-613e245bf2e01a7de11dc9ad8ea155e7.jpg";